export default "__VITE_ASSET__b997d374__"